import React from "react";

const EyeClosedIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5635 18.1093H14.6772V18.0956C19.1909 18.0529 23.1423 15.4716 24.2845 11.7659L24.3179 11.6576L24.2096 11.6239L23.6163 11.4393L23.5073 11.4054L23.4738 11.5144C22.437 14.8839 18.7719 17.249 14.5635 17.249C12.5264 17.249 10.5965 16.7137 8.98125 15.6846C7.43058 14.6943 6.27512 13.3026 5.73086 11.7605L5.69293 11.653L5.58553 11.6912L4.99218 11.9022L4.88567 11.9401L4.9229 12.0468C5.52568 13.7748 6.80953 15.3238 8.51624 16.4039C10.2761 17.5238 12.3677 18.1093 14.5635 18.1093Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M21.532 9.35403L21.6205 9.4277L21.6931 9.33824L22.0886 8.85037L22.1596 8.76284L22.0727 8.69108C20.2417 7.17851 18.3387 6.2185 16.3901 5.87146C14.8289 5.59123 13.2543 5.69812 11.7075 6.19144C9.10028 7.01206 7.47996 8.63398 7.3908 8.72322L7.38932 8.72471L7.3077 8.80633L7.39052 8.88672L7.83884 9.32185L7.95029 9.43002L8.01328 9.30405C8.01516 9.30206 8.01742 9.29969 8.0201 9.29694C8.03173 9.28494 8.04939 9.26727 8.07303 9.24445C8.12024 9.19889 8.19035 9.13372 8.28213 9.05351C8.46568 8.8931 8.73532 8.67312 9.08113 8.43007C9.77308 7.94375 10.7679 7.36662 11.9865 6.98863L11.987 6.98849C13.3937 6.54565 14.8385 6.45465 16.2572 6.71497L16.2573 6.71499C18.0406 7.04041 19.8164 7.92654 21.532 9.35403Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M7.65966 15.0811L7.57547 15.0047L7.49902 15.0889L4.5828 18.3005L4.50636 18.3847L4.59055 18.4611L5.04935 18.8777L5.13354 18.9542L5.20999 18.87L8.1262 15.6584L8.20265 15.5742L8.11846 15.4977L7.65966 15.0811Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M10.8651 16.9073L10.7627 16.8577L10.7131 16.96L8.63693 21.2434L8.58733 21.3457L8.68966 21.3953L9.24732 21.6656L9.34965 21.7152L9.39926 21.6129L11.4754 17.3295L11.5251 17.2272L11.4227 17.1776L10.8651 16.9073Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M14.9942 17.6787V17.565H14.8805H14.2607H14.147V17.6787V22.3596V22.4733H14.2607H14.8805H14.9942V22.3596V17.6787Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M18.6183 16.8059L18.5728 16.7017L18.4686 16.7472L17.9007 16.9954L17.7965 17.041L17.8421 17.1452L19.7908 21.6034L19.8363 21.7076L19.9405 21.662L20.5084 21.4138L20.6126 21.3683L20.567 21.2641L18.6183 16.8059Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
      <path
        d="M21.6309 15.0741L21.5539 14.9903L21.4702 15.0673L21.0139 15.4866L20.9301 15.5635L21.0071 15.6473L23.9602 18.8609L24.0371 18.9447L24.1208 18.8677L24.5772 18.4484L24.6609 18.3715L24.5839 18.2877L21.6309 15.0741Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227437"
        stroke-miterlimit="10"
      />
    </svg>
  );
};

export default EyeClosedIcon;
